// src/services/api.js
import axios from "axios";

const api = axios.create({
  baseURL: "https://be-gizimon-sibm3.karyakreasi.id/api", // Pastikan URL API Anda benar
  headers: {
    Accept: "application/json",
  },
});

// Interceptor untuk mengirim token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;